export default __webpack_public_path__ + "static/media/team3.50faca16.jpg";